import { render } from "./nurse-section.vue?vue&type=template&id=01edb9fb"
import script from "./nurse-section.vue?vue&type=script&lang=js"
export * from "./nurse-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__